<template>
  <div class="mt-4" v-if="showDetail">
    <div class="card top_primary_card bg-primary font-bold text-white p-2 rounded-xl w-full">
      <div class="flex justify-center items-center">
        <h1 class="heading-2 text-center">Update Job</h1>
      </div>
    </div>
    <div class="flex justify-center">
      <div class="card rounded-xl bg-white p-4 my-4 sm:w-full lg:w-10/12 xl:w-8/12 2xl:w-6/12">
        <div class="p-4 pb-0">
          <!-- Customer & Hot Notes Section -->
          <div class="sm:grid grid-cols-2 gap-4">
            <div class="mb-4 sm:mb-0">
              <Dropdown
                :disabled="true"
                :inputext="searchForCustomer"
                :inputId="'searchwp-Customer'"
                :lableText="'Customer'"
                :placholderText="'Customer'"
                :autoFocus="false"
                :showArrow="true"
                :setReadOnly="true"
                :searchCallApi="false"
                :fieldError="errObj.custErr !== ''"
                :showPlus="false"
                :keyName="'companyName'"
                :listId="'customerlistid'"
                :items="[]"
                @enterkeyPressAction="errObj.custErr = ''"
                @inputChangeAction="callsearchCust"
                @addNew="addNewCustomer"
                @selectNewForVal="selectNewCustomer"
              />
              <p v-if="errObj.custErr !== ''" class="text-error heading-7">
                {{ errObj.custErr }}
              </p>
            </div>

            <!-- Hot Notes Section -->
            <div v-if="custDetail !== null" class="mb-4 sm:mb-0 flex items-center">
              <div v-if="custDetail.hotNotes !== ''" class="flex items-center ml-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">
                  <i class="fa-solid fa-pen-to-square h-5 w-5"></i>
                </span>
              </div>
              <div v-if="!showHotNote && custDetail.hotNotes !== ''" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = true" class="text-primary cursor-pointer">Show Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="showHotNote" class="flex items-center px-4 pt-2">
                <span @click="showHotNote = false" class="text-primary cursor-pointer">Hide Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
              <div v-else-if="custDetail.hotNotes === ''" class="flex items-center px-4 pt-2">
                <span @click="showAddNote = true" class="text-primary cursor-pointer">Enter Hot Notes</span>
                <InfoTooltip tooltipText="Hot notes is a note that shows next to customer all the time for you to get a quick information about the customer" position="right" class="ml-2"/>
              </div>
            </div>

            <div v-if="custDetail !== null && showHotNote" class="mb-4 sm:mb-0 flex items-center col-span-2">
              <p class="label_css">Hot Note</p><span style="width: 10px; margin-left: 5px;">: </span><p class="text-error"> {{ custDetail.hotNotes }}</p>
            </div>

            <!-- Job Title -->
            <div class="mb-4 sm:mb-0 col-span-2">
              <TextField
                :inputId="'jobtitlename'"
                :textMaxlength="100"
                :showcharLimit="true"
                :inputext="jobObject.jobTitle"
                :fieldError="errObj.titleErr !== ''"
                :placholderText="'Job Title'"
                :lableText="'Job Title'"
                :autoFocus="false"
                @keyPressAction="errObj.titleErr = ''"
                @inputChangeAction="(data) => (jobObject.jobTitle = data)"
              />
              <p class="text-error heading-7">{{ errObj.titleErr }}</p>
            </div>
          </div>

          <!-- Description & Job Type Section -->
          <div class="sm:grid grid-cols-2 gap-4 mt-6">
            <div class="col-span-2 mb-4 sm:mb-0">
              <TextAreaInput
                :inputId="'jobdescriptioncon'"
                :inputext="jobObject.jobDescription"
                :placholderText="'Write description here...'"
                :lableText="'Job Description'"
                :inputType="'text'"
                :autoFocus="false"
                :textMaxlength="1000"
                :showcharLimit="true"
                class="w-full"
                :setReadOnly="false"
                @inputChangeAction="(data) => (jobObject.jobDescription = data)"
              />
            </div>

            <!-- Job Type Selection -->
            <div class="col-span-2 mb-4 sm:mb-0">
              <p class="label_css flex">Select Job Type<InfoTooltip tooltipText="Job type will help you to categorize jobs based and will help you in reporting" position="right" class="ml-2"/></p>
              <div class="flex flex-wrap mt-2">
                <span v-for="(type, index) in jobTypeList" :key="index">
                  <span
                    @click="selectJobType(type)"
                    :class="`mb-1 cursor-pointer flex items-center justify-center w-fit heading-6 whitespace-nowrap border rounded-2xl text-${jobObject.jobTypeId === type.jobTypeId ? 'primary' : ''} border-${jobObject.jobTypeId === type.jobTypeId ? 'primary' : 'gray2'} px-2 py-1 mr-1`"
                  >
                    {{ type.jobTypeName }}
                  </span>
                </span>
              </div>
            </div>

            <!-- Billing Status -->
            <div class="mb-4 sm:mb-0">
              <p class="label_css flex m-0 p-0">Billing <InfoTooltip tooltipText="Billable will remind you to generate bill before job completion Non Billable will not remind you to create bill on job completion Not application - not yet decided if this job will require billing" position="right" class="ml-2"/></p>

              <div class="flex flex-wrap mt-2 gap-4">
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="true"
                    v-model="jobObject.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Billable</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="false"
                    v-model="jobObject.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Not Billable</span>
                </label>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="billingStatus"
                    :value="null"
                    v-model="jobObject.isBillable"
                    class="mr-2 cursor-pointer"
                  />
                  <span class="heading-6">Not Applicable</span>
                </label>
              </div>
            </div>
          </div>

          <!-- VIP Job Checkbox -->
          <div class="flex space-x-10 col-span-2 mt-4 sm:mb-0">
            <div class="flex items-center py-1">
              <CheckBoxInput
                :checkValue="jobObject.isVipJob"
                :label="'VIP Job'"
                :size="'small'"
                :disabled="false"
                @setIsActive="jobObject.isVipJob = !jobObject.isVipJob"
              />
              <InfoTooltip tooltipText="VIP Job will show a Star in job list and detail for you to know its an important job" position="right" class="ml-2"/>
            </div>
          </div>

          <!-- Job Location Section (Same as Create Job) -->
          <div v-if="custDetail !== null" class="mb-4 sm:mb-0 col-span-2 mt-6">
            <Dropdown
              :disabled="!showAddSelectAddr"
              :lableText="'Job Location'"
              :placholderText="'Select job location'"
              :inputext="selectedAddressLabel"
              :showArrow="true"
              :setReadOnly="false"
              :searchCallApi="false"
              :fieldError="errObj.addressErr !== ''"
              :keyName="'label'"
              :autoFocus="false"
              :showPlus="true"
              :showClearIcon="true"
              :inputId="'address-dropdown'"
              :listId="'address-list'"
              :items="addressDropdownItems"
              @selectNewForVal="handleAddressSelect"
              @addNew="addNewAddress"
            />
            <p v-if="errObj.addressErr !== ''" class="text-error heading-7">
              {{ errObj.addressErr }}
            </p>

            <!-- Show distance below if selected -->
            <p v-if="selectedAddress && selectedAddress.type === 'customer'" class="text-text2 heading-7 mt-1">
              {{ selectedAddress.data.displayDistance }}
            </p>
            <p v-else-if="isOfficeAddressSel" class="text-text2 heading-7 mt-1">
              Office Location Selected
            </p>
            <p v-else-if="isAddedNewAddress" class="text-error heading-7 mt-1">
              {{ otherLocationDistance }}
            </p>

            <!-- Show "Add to customer" checkbox only for new address -->
            <div v-if="isAddedNewAddress" class="flex items-center mt-2">
              <CheckBoxInput
                :checkValue="jobObject.isAddressAddToCustomer"
                :label="''"
                :size="'small'"
                :disabled="false"
                @setIsActive="jobObject.isAddressAddToCustomer = !jobObject.isAddressAddToCustomer"
              />
              <span class="pl-0 text-text2 cursor-pointer" @click.stop.prevent="jobObject.isAddressAddToCustomer = !jobObject.isAddressAddToCustomer">
                Add address in customer file
              </span>
            </div>
          </div>

          <!-- Schedule & Assignee Section -->
          <div class="grid grid-cols-2 gap-4 mt-6">
            <div class="col-span-2">
              <div class="card rounded-lg border border-gray2 bg-white overflow-hidden">
                <!-- Card Header -->
                <div class="flex justify-between items-center p-4">
                  <div class="flex items-center">
                    <span class="heading-5 font-semibold text-text1">Schedule and User Assignment</span>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="border-t border-gray2">
                  <div class="p-4">
                    <SheduleVisit
                      :sTime="ssTime"
                      :eTime="eeTime"
                      :assignUser="assignUser"
                      :isFromSchedule="false"
                      :title="'Schedule'"
                      :showEmployeeSelection="true"
                      :showJobItemSelection="false"
                      :visitErr="visitErr"
                      :jobDetail="jobDetail"
                      :isCreateJob="false"
                      :isShowJobSection="false"
                      :setDefaultTime="ssTime !== '' && eeTime !== '' ? true : false"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Expandable Card for Additional Options -->
            <div class="col-span-2 mt-4">
              <div class="card rounded-lg border border-gray2 bg-white overflow-hidden expandable-card">
                <!-- Card Header - Clickable to expand/collapse -->
                <div
                  @click="showMore = !showMore"
                  class="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors"
                >
                  <div class="flex items-center">
                    <span class="heading-5 font-semibold text-text1">Additional Options</span>
                  </div>
                  <i
                    :class="['fa-solid fa-chevron-down text-primary transition-transform duration-300', showMore ? 'rotate-180' : '']"
                  ></i>
                </div>

                <!-- Card Body - Expandable Content -->
                <div v-if="showMore" class="border-t border-gray2">
                  <div class="p-4">
                    <div class="mb-4">
                      <JobItemSelect />
                    </div>
                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <p v-if="jobCheckList.length > 0" class="label_css mb-2">Job Checklist</p>
                      <div>
                        <div v-if="jobCheckList.length > 0" class="mb-3">
                          <div v-for="(item, ch) in jobCheckList" :key="ch" class="p-3 mb-2 border border-gray2 rounded-lg bg-white">
                            <div class="flex items-center">
                              <span class="text-text1 heading-6">{{ item.checkLiTitle }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="flex">
                          <span @click="openChecklistPopup" class="text-primary font-bold cursor-pointer">
                            {{ jobCheckList.length > 0 ? '' : '+' }} Add{{ jobCheckList.length > 0 ? '/Edit' : '' }} Checklist
                          </span>
                          <InfoTooltip tooltipText="Checklist will help you to check things before you leave for the job" position="right" class="ml-2"/>
                        </div>
                      </div>
                    </div>

                    <div class="divider mb-4 mt-4"></div>

                    <div class="mb-4">
                      <p v-if="stepThreeObj.toolList.length > 0" class="label_css mb-2">Tool list:</p>
                      <div>
                        <div v-if="stepThreeObj.toolList.length > 0" class="mb-3">
                          <div v-for="(tool, ind) in stepThreeObj.toolList" :key="ind" class="p-3 mb-2 border border-gray2 rounded-lg bg-white">
                            <div class="flex items-center">
                              <span class="text-text1 heading-6">{{ tool.toolName }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="flex">
                          <span @click="isSelectTool = true" class="text-primary font-bold cursor-pointer">
                            {{ stepThreeObj.toolList.length > 0 ? '' : '+' }} Add{{ stepThreeObj.toolList.length > 0 ? '/Edit above' : '' }} Tools
                          </span>
                          <InfoTooltip tooltipText="Tools will help you to carry tools before you start the day so that you don't miss anything during the job" position="right" class="ml-2"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save and Cancel Buttons -->
          <div class="flex justify-end col-span-2 mt-6">
            <div class="text-right flex gap-2">
              <Button
                :btnSize="'medium'"
                :textColor="'text1'"
                :btnColor="'gray1'"
                :btnText="'Cancel'"
                @buttonAction="$router.go(-1)"
              />
              <Button
                :btnSize="'medium'"
                :textColor="'white'"
                :btnColor="'success'"
                :btnText="'Update'"
                @buttonAction="update()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation Popup -->
    <div v-if="confPopup" class="popup_overlay relative px-4">
      <div style="width: 380px;" class="custom_dialog rounded-xl h-min p-4 text-center">
        <div class="mb-2">
          <p class="heading-3 text-text1">Select the job update option</p>
        </div>
        <div class="divider"></div>
        <div class="">
          <p class="heading-4 text-gray4 my-2 cursor-pointer hover:bg-gray-50" @click="updateJob(false)">Update only this job</p>
          <p class="heading-4 text-gray4 cursor-pointer hover:bg-gray-50" @click="updateJob(true)">Update this and all Future job</p>
        </div>
        <div class="mb-5"></div>
        <div class="flex gap-2 justify-end">
          <Button :btnSize="'medium'" :textColor="'text1'" :btnColor="'gray1'" :btnText="'Cancel'" @buttonAction="confPopup = false"/>
        </div>
      </div>
    </div>

    <AddCustomer v-if="addCustomer" />
    <UpdateCompanyInfo
      v-if="showAddNote"
      :dialogTtile="'Update Hot Notes'"
      :updateCustData="custDetail"
    />
    <AddAddressForCreateJob
      v-if="addOther"
      :addJobObj="jobObject"
      :addressList="addressList"
      @SearchNewAddress="SearchNewAddress"
      @SetLocationCreateJobHanler="SetLocationCreateJobHanler"
    />
    <SelectTools
      @uppdateToollist="uppdateToollist"
      :toolList="toolMainList"
      @selectToolHandler="selectToolHandler"
      v-if="isSelectTool"
    />
    <SelectChecklist
      :checklist="jobCheckList"
      @checklistHandler="handleChecklistSave"
      v-if="isSelectChecklist"
    />
  </div>
</template>

<script>
import moment from 'moment'
import MyJobApp from "@/api/MyJobApp.js";
import Button from '@/View/components/globalButton.vue'
import AddCustomer from '@/View/customer/components/AddCustomer.vue'
import TextAreaInput from '@/View/components/textAreaInput.vue'
import SheduleVisit from '../SheduleVisit.vue'
import TextField from '@/View/components/textfield.vue'
import deboucneMixin from '@/mixins/debounce.js'
import Dropdown from '@/View/components/dropdown.vue'
import CheckBoxInput from '../../../components/checkBoxInput.vue';
import UpdateCompanyInfo from '../../../customer/components/UpdateCompanyInfo.vue';
import InfoTooltip from '@/View/components/InfoTooltip.vue';
import SelectTools from '../selectTools.vue';
import SelectChecklist from '../SelectChecklist.vue';
import JobItemSelect from '../JobItemSelect.vue';
import AddAddressForCreateJob from '../AddAddressForCreateJob.vue';
import timeZoneWithCountryCode from '@/assets/timeZoneWithCountryCode.json';
import milesCountry from '@/assets/milesCountry.json';

export default {
  name: "updateJob",
  components: {
    Dropdown,
    AddCustomer,
    Button,
    TextAreaInput,
    TextField,
    SheduleVisit,
    CheckBoxInput,
    UpdateCompanyInfo,
    InfoTooltip,
    SelectTools,
    SelectChecklist,
    JobItemSelect,
    AddAddressForCreateJob,
  },
  mixins: [deboucneMixin],
  data() {
    return {
      addCustomer: false,
      customersList: [],
      jobTypeList: [],
      searchApitext: '',
      searchForCustomer: '',
      addTaskDesc: false,
      confPopup: false,
      showDetail: false,
      showMore: false,
      jobDetail: {},
      custDetail: null,
      showAddNote: false,
      showHotNote: false,
      isSelectTool: false,
      isSelectChecklist: false,
      errObj: {
        custErr: '',
        titleErr: '',
        addressErr: ''
      },
      scheduleDate: '',
      jobObject: {
        jobId: 0,
        customerId: 0,
        visitId: 0,
        customerAddressId: 0,
        jobTitle: '',
        jobDescription: '',
        visitStartTime: '',
        visitEndTime: '',
        assignToList: [],
        isTimeErr: false,
        isVipJob: false,
        isBillable: false,
        jobTypeId: 0,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        latitude: 0,
        longitude: 0,
        fullAddress: '',
        houseNo: '',
        floorNumber: '',
        buildingName: '',
        directionNote: '',
        contactNumber: '',
        contactName: '',
        addressTitle: '',
        isAddressAddToCustomer: false,
      },
      stepThreeObj: {
        jobId: 0,
        visitList: [],
        isUnschedule: false,
        assignToList: [],
        itemList: [],
        toolList: [],
      },
      jobCheckList: [],
      hourInputValue: 0,
      minInputValue: 0,
      displayJobTypeName: '',
      displayEstimation: '',
      getCustList: () => {},
      addressList: [],
      addressDropdownItems: [],
      selectedAddress: null,
      selectedAddressLabel: '',
      showAddSelectAddr: false,
      isOfficeAddressSel: false,
      isAddedNewAddress: false,
      otherLocationDistance: '',
      addOther: false,
      addNewjobAdd: false,
      LoginUserlatLong: null,
      OfficelatLong: null,
      toolMainList: [],
      visitCheckList: '',
      ssTime: '',
      eeTime: '',
      assignUser: 0,
      visitErr: false,
    };
  },
  created() {
    window.addEventListener('resize', this.resizeWindowHandler())
  },
  computed: {},
  watch: {
    jobObject: {
      handler() {
        console.log('jobObject------------------->>>>>>>>----------------->>>>>', this.jobObject)
        if (this.jobObject.customerId > 0) {
          this.customersList.forEach(e => {
            if (e.customerId === this.jobObject.customerId) {
              this.jobObject.customerAddressId = 0
              this.errObj.custErr = ''
              this.searchForCustomer = e.companyName
            }
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.LoginUserlatLong = JSON.parse(localStorage.getItem('LoginUserlatLong'));
    this.OfficelatLong = JSON.parse(localStorage.getItem('orgInfo'));

    this.$root.$on("addCustomerHandler", (response, data) => {
      if (response && this.addCustomer) {
        this.selectNewCustomer(data)
      }
      this.addCustomer = false
    });

    this.$root.$on("updateCustHandler", (response) => {
      this.showAddNote = false;
      if (response && this.custDetail) {
        this.getCustDetails(this.custDetail.customerId);
      }
    });

    this.$root.$on("createjobAddressHandler", (response, data) => {
      if (response && data !== null && this.addOther) {
        this.setAddress(data, false);
      }
      this.addOther = false;
    });

    this.$root.$on('EditAddressHandler', () => {
      if (this.addNewjobAdd) {
        this.addNewjobAdd = false;
      }
    });

    this.$root.$on('setItemSelectedHandler', (response) => {
      this.stepThreeObj.itemList = response;
    });

    this.getCustList = this.debounce(function() {
      this.getCustomerList()
    }, 500)
    this.getCustomerList()
    this.getJobDetail()
    this.jobTypelist()
    this.getToolList()
    console.log("route", this.$route.query);

    this.$root.$on('setSelectedEmpHandler', (response) => {
      this.jobObject.assignToList = response
      this.stepThreeObj.assignToList = response
    })
    this.$root.$on('scheduleTimeEmit', (response) => {
      console.log('scheduleTimeEmit received:', response)
      console.log('Setting visitStartTime to:', response.compStartTime)
      console.log('Setting visitEndTime to:', response.compEndTime)
      this.jobObject.visitStartTime = response.compStartTime
      this.jobObject.visitEndTime = response.compEndTime
      this.ssTime = new Date(response.compStartTime)
      this.eeTime = new Date(response.compEndTime)
      this.jobObject.jobDate = moment(new Date(response.compStartTime)).format('YYYY-MM-DD')
      this.jobObject.isTimeErr = response.Error
      this.visitErr = response.Error
    })

    this.$root.$on('finalvisitlistHandler', (response) => {
      if (response[0].isUnschedule) {
        this.stepThreeObj.visitList = [];
        this.stepThreeObj.isUnschedule = true;
      } else {
        this.stepThreeObj.visitList = response;
        this.stepThreeObj.isUnschedule = false;
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("addCustomerHandler");
    this.$root.$off("updateCustHandler");
    this.$root.$off("setSelectedEmpHandler");
    this.$root.$off("scheduleTimeEmit");
    this.$root.$off("createjobAddressHandler");
    this.$root.$off("EditAddressHandler");
    this.$root.$off("setItemSelectedHandler");
    this.$root.$off("finalvisitlistHandler");
  },
  methods: {
    selectNewCustomer(data) {
      if (data !== null) {
        this.jobObject.customerAddressId = 0
        this.errObj.custErr = ''
        this.searchForCustomer = data.companyName
        this.jobObject.customerId = data.customerId
        // Reset address when changing customer
        this.resetAddressFields();
        this.addressList = [];
        this.addressDropdownItems = [];
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        // Get customer details for hot notes and addresses
        this.getCustDetails(data.customerId);
      } else {
        this.searchForCustomer = ''
        this.jobObject.customerId = 0
        this.custDetail = null
      }
    },
    addNewCustomer() {
      this.addCustomer = true
    },
    getCustDetails(custId) {
      MyJobApp.getCustomerDetail(
        custId,
        (response) => {
          this.custDetail = response.Data;
          this.setCustomerDetail();
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    setCustomerDetail() {
      this.searchForCustomer = this.custDetail.companyName;
      this.addressDropdownItems = [];
      this.addressList = [];

      // ---------- 1. Customer addresses ----------
      if (this.custDetail.addressList && this.custDetail.addressList.length) {
        this.custDetail.addressList.forEach(e => {
          let dist = 0;
          let suffix = '';
          if (this.LoginUserlatLong) {
            dist = this.calcDistance(
              this.LoginUserlatLong.latitude,
              this.LoginUserlatLong.longitude,
              e.latitude,
              e.longitude
            );
            suffix = ' from user';
          } else if (this.OfficelatLong) {
            dist = this.calcDistance(
              this.OfficelatLong.latitude,
              this.OfficelatLong.longitude,
              e.latitude,
              e.longitude
            );
            suffix = ' from office';
          }
          const distanceLabel = this.getDistanceUnit(dist * 1000) + suffix;

          const addrObj = {
            ...e,
            selected: false,
            displayDistance: distanceLabel,
            addressText: `(${e.addressTitle || 'Other'}) - ${e.fullAddress}`
          };

          this.addressList.push(addrObj);

          this.addressDropdownItems.push({
            label: addrObj.addressText,
            value: { type: 'customer', data: addrObj }
          });
        });
      }

      // ---------- 2. Office location ----------
      this.addressDropdownItems.push({
        label: 'Office Location',
        value: { type: 'office' }
      });

      // ---------- 3. Find and select the current job address ----------
      this.showAddSelectAddr = true;

      // Try to match the current job address with customer addresses
      let matchingAddress = null;
      if (this.jobObject.fullAddress) {
        matchingAddress = this.addressList.find(addr =>
          addr.fullAddress === this.jobObject.fullAddress ||
          (addr.latitude === this.jobObject.latitude && addr.longitude === this.jobObject.longitude)
        );
      }

      if (matchingAddress) {
        // Found a matching customer address
        this.$nextTick(() => {
          const matchingItem = this.addressDropdownItems.find(item =>
            item.value.type === 'customer' &&
            item.value.data.fullAddress === matchingAddress.fullAddress
          );
          if (matchingItem) {
            this.handleAddressSelect(matchingItem);
          }
        });
      } else if (!this.jobObject.fullAddress || (this.jobObject.latitude === 0 && this.jobObject.longitude === 0)) {
        // No address set, select office location
        this.$nextTick(() => {
          const officeItem = this.addressDropdownItems.find(item => item.value.type === 'office');
          if (officeItem) {
            this.handleAddressSelect(officeItem);
          }
        });
      } else {
        // Address doesn't match any customer address, it's a custom/other location
        this.isAddedNewAddress = true;
        this.selectedAddressLabel = this.jobObject.addressTitle || 'Other Location';

        // Calculate distance for the other location
        let dist = 0;
        let suffix = '';
        if (this.LoginUserlatLong) {
          dist = this.calcDistance(
            this.LoginUserlatLong.latitude,
            this.LoginUserlatLong.longitude,
            this.jobObject.latitude,
            this.jobObject.longitude
          );
          suffix = ' from user';
        } else if (this.OfficelatLong) {
          dist = this.calcDistance(
            this.OfficelatLong.latitude,
            this.OfficelatLong.longitude,
            this.jobObject.latitude,
            this.jobObject.longitude
          );
          suffix = ' from office';
        }
        this.otherLocationDistance = this.getDistanceUnit(dist * 1000) + suffix;
      }
    },
    handleAddressSelect(item) {
      console.log("handleAddressSelect - full item:", item);

      const selected = item ? item.value : null;

      this.errObj.addressErr = "";

      if (!selected) {
        this.selectedAddress = null;
        this.selectedAddressLabel = '';
        this.resetAddressFields();
        return;
      }

      this.selectedAddress = selected;

      this.selectedAddressLabel = selected.type === 'customer'
        ? (selected.data.addressTitle || 'Other')
        : 'Office Location';

      if (selected.type === 'customer') {
        this.selectJobAddress(selected.data, -1);
        this.isOfficeAddressSel = false;
        this.isAddedNewAddress = false;
      } else if (selected.type === 'office') {
        this.checkboxCheck();
        this.isOfficeAddressSel = true;
        this.isAddedNewAddress = false;
      }
    },
    resetAddressFields() {
      this.jobObject.addressLine1 = "";
      this.jobObject.addressLine2 = "";
      this.jobObject.city = "";
      this.jobObject.state = "";
      this.jobObject.zip = "";
      this.jobObject.latitude = 0;
      this.jobObject.longitude = 0;
      this.jobObject.fullAddress = "";
      this.jobObject.addressTitle = "";
      this.isOfficeAddressSel = false;
      this.isAddedNewAddress = false;
    },
    selectJobAddress(data, index) {
      this.isOfficeAddressSel = false;
      this.addressList.forEach((e, i) => {
        e.selected = index === i;
      });
      this.isAddedNewAddress = false;
      this.jobObject.isAddressAddToCustomer = false;
      this.jobObject.addressTitle = data !== null ? data.addressTitle : "";
      this.jobObject.fullAddress = data !== null ? data.fullAddress : "";
      this.jobObject.addressLine1 = data !== null ? data.addressLine1 : "";
      this.jobObject.addressLine2 = data !== null ? data.addressLine2 : "";
      this.jobObject.city = data !== null ? data.city : "";
      this.jobObject.state = data !== null ? data.state : "";
      this.jobObject.zip = data !== null ? data.zip : "";
      this.jobObject.latitude = data !== null ? data.latitude : 0;
      this.jobObject.longitude = data !== null ? data.longitude : 0;
      this.jobObject.country = data !== null ? data.country : "";
      this.jobObject.directionNote = data !== null ? data.directionNote : "";
      this.jobObject.houseNo = data !== null ? data.houseNo : "";
      this.jobObject.floorNumber = data !== null ? data.floorNumber : "";
      this.jobObject.buildingName = data !== null ? data.buildingName : "";
    },
    checkboxCheck() {
      this.addressList.forEach(e => { e.selected = false; });
      this.isOfficeAddressSel = true;
      this.isAddedNewAddress = false;
      this.errObj.addressErr = "";
      this.jobObject.isAddressAddToCustomer = false;
      this.jobObject.fullAddress = "";
      this.jobObject.addressTitle = "";
      this.jobObject.addressLine1 = "";
      this.jobObject.addressLine2 = "";
      this.jobObject.city = "";
      this.jobObject.state = "";
      this.jobObject.zip = "";
      this.jobObject.latitude = 0;
      this.jobObject.longitude = 0;
      this.jobObject.country = "";
      this.jobObject.directionNote = "";
      this.jobObject.houseNo = "";
      this.jobObject.floorNumber = "";
      this.jobObject.buildingName = "";
    },
    addNewAddress() {
      this.addOther = true;
    },
    SearchNewAddress(isActive) {
      this.addNewjobAdd = isActive;
    },
    SetLocationCreateJobHanler() {
      this.addOther = false;
    },
    setAddress(data, isNotNew) {
      if (!isNotNew) {
        this.isAddedNewAddress = true;
        let temp = 0;
        let temp3 = '';
        if (this.LoginUserlatLong !== null) {
          temp = this.calcDistance(this.LoginUserlatLong.latitude, this.LoginUserlatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from user`;
        } else {
          temp = this.calcDistance(this.OfficelatLong.latitude, this.OfficelatLong.longitude, data.latitude, data.longitude);
          temp3 = ` from office`;
        }
        let value = this.getDistanceUnit(temp * 1000);
        this.otherLocationDistance = value + temp3;
        this.isOfficeAddressSel = false;
        this.jobObject.isAddressAddToCustomer = true;
        this.addressList.forEach(e => { e.selected = false; });
      }
      this.jobObject.addressTitle = data !== null ? data.addressTitle : "";
      this.jobObject.addressLine1 = data !== null ? data.addressLine1 : "";
      this.jobObject.addressLine2 = data !== null ? data.addressLine2 : "";
      this.jobObject.city = data !== null ? data.city : "";
      this.jobObject.state = data !== null ? data.state : "";
      this.jobObject.zip = data !== null ? data.zip : "";
      this.jobObject.latitude = data !== null ? data.latitude : 0;
      this.jobObject.longitude = data !== null ? data.longitude : 0;
      this.jobObject.country = data !== null ? data.country : "";
      this.jobObject.fullAddress = data !== null ? data.fullAddress : "";
      this.jobObject.houseNo = data !== null ? data.houseNo : "";
      this.jobObject.floorNumber = data !== null ? data.floorNumber : "";
      this.jobObject.buildingName = data !== null ? data.buildingName : "";
      this.jobObject.directionNote = data !== null ? data.directionNote : "";
      this.jobObject.contactNumber = data !== null ? data.contactNumber : "";
      this.jobObject.contactName = data !== null ? data.contactName : "";
    },
    openChecklistPopup() {
      this.isSelectChecklist = true;
    },
    handleChecklistSave(checklist) {
      if (checklist !== null) {
        this.jobCheckList = checklist;
      }
      this.isSelectChecklist = false;
    },
    uppdateToollist(data) {
      this.toolMainList.push(data);
    },
    selectToolHandler(data) {
      if (data !== null) {
        this.stepThreeObj.toolList = data;
      }
      this.isSelectTool = false;
    },
    getToolList() {
      MyJobApp.getToolList(
        (response) => {
          response.Data.forEach(element => {
            this.toolMainList.push({ ...element, selected: false });
          });
        },
        () => {
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    update() {
      console.log('this.jobObject---> SAVE---> ', this.jobObject)
      this.jobObject.assignToList = this.jobObject.assignToList === null ? [] : this.jobObject.assignToList
      if (this.jobObject.assignToList.length === 0) {
        this.jobObject.reminderBeforeMinutes = 0
      }
      let isValid = true
      if (this.jobObject.jobTitle.trim() === '') {
        this.errObj.titleErr = 'Title is required'
        isValid = false
      }
      if (this.jobObject.isTimeErr || this.visitErr) {
        isValid = false
      }
      if (this.jobObject.assignToList.length === 0) {
        this.$root.$emit('assigneeErr', true)
        isValid = false
      }
      if (isValid) {
        if (this.jobDetail.isRepeated) {
          this.confPopup = true
        } else {
          this.updateJob(false)
        }
      }
    },
    jobTypelist() {
      MyJobApp.jobTypelist(
        (response) => {
          this.jobTypeList = response.Data;
        },
        (err) => {
          this.$store.dispatch("SetAlert", { showAlert: true, message: err.message, color: "error" });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    selectJobType(data) {
      this.jobCheckList = JSON.parse(data.jobCheckList);
      this.hourInputValue = 1440;
      this.minInputValue = 0;
      this.jobObject.jobTypeId = data.jobTypeId;
      this.displayJobTypeName = data.jobTypeName;
      this.setDisplayEstimation();
    },
    setDisplayEstimation() {
      this.displayEstimation = '24 Hr';
    },
    updateJob(value) {
      this.confPopup = false
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      console.log("value", value)

      // Prepare the update object with all necessary data
      let updateData = {
        ...this.jobObject,
        visitCheckList: JSON.stringify(this.jobCheckList.filter(item => item.checkLiTitle.trim() !== '')),
        itemList: this.stepThreeObj.itemList,
        toolList: this.stepThreeObj.toolList,
      };

      MyJobApp.UpdateAllJobDetail(
        updateData,
        (response) => {
          this.$router.push({ name: 'jobDetail', params: { jobId: response.Data } })
          this.$store.dispatch('SetAlert', { showAlert: true, message: response.message, color: 'success' })
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        },
        (error) => {
          this.$store.dispatch('SetAlert', { showAlert: true, message: error.message, color: 'error' })
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        }
      );
    },
    loadVisitItems(visitId) {
      console.log("loadVisitItems called with visitId:", visitId, "jobId:", this.jobObject.jobId);
      MyJobApp.getVisitItemList(
        visitId,
        this.jobObject.jobId,
        response => {
          console.log("Visit items API response:", response);
          if (response.Data.tableRow && response.Data.tableRow.length > 0) {
            this.stepThreeObj.itemList = response.Data.tableRow;
            console.log("Items loaded:", this.stepThreeObj.itemList);
            this.$root.$emit('getUnscheduleObject', { itemList: response.Data.tableRow });
            console.log("Emitted getUnscheduleObject event");
          } else {
            console.log("No items found in response");
          }
        },
        (error) => {
          console.error('Failed to load visit items:', error);
        }
      );
    },
    getJobDetail() {
      this.$store.dispatch("SetLoader", { status: true, message: "Loading..." });
      MyJobApp.getJobDetail(
        parseInt(this.$route.params.jobId),
        (response) => {
          this.jobDetail = response.Data !== null ? response.Data : null
          this.jobObject.jobTitle = response.Data.jobTitle
          this.jobObject.jobDescription = response.Data.jobDescription || ''
          this.jobObject.customerId = response.Data.customerId
          this.jobObject.jobId = response.Data.jobId
          this.jobObject.jobTypeId = response.Data.jobTypeId
          this.jobObject.visitStartTime = response.Data.visitList[0]?.visitStartDateTime || response.Data.completeVisitList[0]?.visitStartDateTime
          this.jobObject.visitEndTime = response.Data.visitList[0]?.visitEndDateTime || response.Data.completeVisitList[0]?.visitEndDateTime
          this.jobObject.visitId = response.Data.visitList[0]?.visitId || response.Data.completeVisitList[0]?.visitId
          this.jobObject.isBillable = response.Data.isBillable
          this.jobObject.isVipJob = response.Data.isVipJob

          // Set schedule times for the SheduleVisit component
          if (this.jobObject.visitStartTime) {
            this.ssTime = new Date(this.jobObject.visitStartTime);
          }
          if (this.jobObject.visitEndTime) {
            this.eeTime = new Date(this.jobObject.visitEndTime);
          }

          // Set address fields
          this.jobObject.addressLine1 = response.Data.addressLine1 || '';
          this.jobObject.addressLine2 = response.Data.addressLine2 || '';
          this.jobObject.city = response.Data.city || '';
          this.jobObject.state = response.Data.state || '';
          this.jobObject.zip = response.Data.zip || '';
          this.jobObject.country = response.Data.country || '';
          this.jobObject.latitude = response.Data.latitude || 0;
          this.jobObject.longitude = response.Data.longitude || 0;
          this.jobObject.fullAddress = response.Data.fullAddress || '';
          this.jobObject.houseNo = response.Data.houseNo || '';
          this.jobObject.floorNumber = response.Data.floorNumber || '';
          this.jobObject.buildingName = response.Data.buildingName || '';
          this.jobObject.directionNote = response.Data.directionNote || '';
          this.jobObject.contactNumber = response.Data.contactNumber || '';
          this.jobObject.contactName = response.Data.contactName || '';
          this.jobObject.addressTitle = response.Data.addressTitle || '';

          // Get customer details for hot notes and addresses
          this.getCustDetails(response.Data.customerId);

          // Get visit data
          let visit = null;
          if (response.Data.visitList && response.Data.visitList.length > 0) {
            visit = response.Data.visitList[0];
          } else if (response.Data.completeVisitList && response.Data.completeVisitList.length > 0) {
            visit = response.Data.completeVisitList[0];
          }

          if (visit) {
            // Set assigned users
            if (visit.visitAssignee && visit.visitAssignee.length > 0) {
              this.jobObject.assignToList = visit.visitAssignee.map(assignee => ({
                userDetailId: assignee.userDetailId,
                firstName: assignee.firstName,
                lastName: assignee.lastName
              }));
              this.stepThreeObj.assignToList = this.jobObject.assignToList;
              console.log("assignToList set to:", this.jobObject.assignToList);
            }

            // Parse checklist if exists
            if (visit.visitCheckList && visit.visitCheckList !== '') {
              try {
                this.jobCheckList = JSON.parse(visit.visitCheckList);
                console.log("Checklist parsed:", this.jobCheckList);
              } catch (e) {
                console.error("Failed to parse checklist:", e);
                this.jobCheckList = [];
              }
            }

            // Set tools
            if (visit.toolList && visit.toolList.length > 0) {
              this.stepThreeObj.toolList = visit.toolList;
              console.log("Tools set to:", this.stepThreeObj.toolList);
            }

            // Load items for the visit
            if (visit.visitId) {
              console.log("Loading items for visitId:", visit.visitId);
              this.loadVisitItems(visit.visitId);
            }
          }

          this.showDetail = true

          this.$store.dispatch("SetLoader", { status: false, message: "" });
        },
        (err) => {
          console.error("Error in getJobDetail:", err);
          this.$store.dispatch('SetAlert', { showAlert: true, message: err.message, color: 'error' });
          this.$store.dispatch("SetLoader", { status: false, message: "" });
        }
      );
    },
    resizeWindowHandler() {
      this.cardHeight = window.innerHeight - 158
    },
    callsearchCust(text) {
      this.searchApitext = text
      this.getCustList()
    },
    getCustomerList() {
      this.customersList = []
      MyJobApp.getGlobalCustLeadList(
        0,
        500,
        this.searchApitext,
        '',
        response => {
          let tempList = response.Data.tableRow !== null ? response.Data.tableRow : []
          tempList.forEach(e => {
            let lead = e.isLead ? '(lead)' : '(customer)'
            e.companyName = e.companyName + ' ' + lead
            this.customersList.push(e)
          });
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        },
        () => {
          this.resetPaginationValues = false
          this.$store.dispatch('SetLoader', { status: false, message: '' })
        }
      )
    },
    getDistanceUnit(distanceMeter) {
      let distance = '';
      let countryCode;
      const moment = require('moment-timezone');
      const countryTimeZone = moment.tz.guess();
      timeZoneWithCountryCode.map(itm => {
        const ind = itm.timezones.findIndex(x => x.name === countryTimeZone);
        if (ind >= 0) {
          countryCode = itm.code;
        }
      });
      const index = milesCountry.findIndex(x => x.countryCode === countryCode);
      if (index >= 0) {
        if (distanceMeter * 0.00062137 >= 1000) {
          distance = `999+ mi`;
        } else if (distanceMeter * 0.00062137 < 0.1) {
          distance = '';
        } else {
          distance = `${(distanceMeter * 0.00062137).toFixed(1)} mi`;
        }
      } else if (distanceMeter / 1000 >= 1000) {
        distance = `999+ km`;
      } else if (distanceMeter / 1000 < 0.1) {
        distance = '';
      } else {
        distance = `${(distanceMeter / 1000).toFixed(1)} km`;
      }
      return distance;
    },
    calcDistance(lat1, lon1, lat2, lon2) {
      const radius = 6371;
      const dLat = this.toRadians(lat2 - lat1);
      const dLng = this.toRadians(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = radius * c;
      return distance.toFixed(2);
    },
    toRadians(degree) {
      return degree * (Math.PI / 180);
    },
  },
};
</script>

<style scoped>
.popup_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;
}

.custom_dialog {
  background: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.expandable-card {
  transition: all 0.3s ease;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
